import type { GridlinesType } from '@src/slide/domain/ui-model/element-modeles/constant/chart';
import type {
    IValuesRange,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/sub-chart/base-sub-chart.interface';
import type {
    IAxisTitleProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/axis/axis-title.interface';
import type { IChartAxis } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-properties.interface';
import type {
    IChartShapeProperty,
} from '@src/slide/domain/ui-model/element-modeles/property/chart/chart-shape-property.interface';
import type { IGridLineProperty } from '@src/slide/domain/ui-model/element-modeles/property/chart/axis/grid-line.interface';

export type AxisType = 'category' | 'date' | 'value';
export interface IAxisProperty extends IChartShapeProperty<IChartAxis>, Omit<IChartAxis, 'title' | 'majorGridlines' | 'minorGridlines'> {
    name: AxisName;
    values: number[];
    /**
     * 根据坐标轴上的点，计算出的坐标轴规则，包含单位、区间等
     */
    scale?: IValueAxisScale;
    ticks?: number[];
    title?: IAxisTitleProperty;
    majorGridlines?: IGridLineProperty;
    minorGridlines?: IGridLineProperty;
    setAxisName(name: AxisName): void;
    setValues(values: number[], range?: IValuesRange): void;
    showAxis(): void;
    hideAxis(): void;
    createAxisTitle(): void;
    removeAxisTitle(): void;
    createGridlines(gridlinesTypes: GridlinesType[]): void;
    removeGridlines(gridlinesTypes: GridlinesType[]): void;
}

export enum AxisName {
    PRIMARY_HORIZONTAL = 'PRIMARY_HORIZONTAL',
    PRIMARY_VERTICAL = 'PRIMARY_VERTICAL',
    SECONDARY_HORIZONTAL = 'SECONDARY_HORIZONTAL',
    SECONDARY_VERTICAL = 'SECONDARY_VERTICAL',
}

export interface IValueAxisScale {
    min: number,
    max: number,
    majorUnit: number;
    minorUnit: number;
}
